import PropTypes from 'prop-types';
import { find, path, propEq } from 'ramda';
import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';

import { connect } from 'react-redux';
import { readEndpoint, updateResource } from 'redux-json-api';
import { SubmissionError } from 'redux-form';

import { closeLeftBarModule, showSnackbarMessage } from '../../modules/actions/layout';
import BusForm from './Form';

class BusEdit extends Component {
  static propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    readEndpoint: PropTypes.func.isRequired,
    updateResource: PropTypes.func.isRequired,
    closeLeftBarModule: PropTypes.func.isRequired,
    showSnackbarMessage: PropTypes.func.isRequired,
    extra: PropTypes.shape({}),
  };

  componentWillMount() {
    const { readEndpoint, extra: { id } } = this.props;

    readEndpoint(`vehicle/${id}`);
  };

  render() {
    const { bus, apiEndpoint, updateResource, closeLeftBarModule, showSnackbarMessage } = this.props;
    const initialValues = {
      license_plate: path(['attributes', 'license-plate'], bus),
      vehicle_number: path(['attributes', 'vehicle-number'], bus),
      year_of_registration: path(['attributes', 'year-of-registration'], bus),
      euronorm: path(['attributes', 'euronorm'], bus),
      seats: path(['attributes', 'seats'], bus),
      standing_places: path(['attributes', 'standing-places'], bus),
      bikes_allowed: path(['attributes', 'bikes-allowed'], bus),
      toilet_available: path(['attributes', 'toilet-available'], bus),
      photo: path(['attributes', 'photo'], bus),
      company: path(['relationships', 'company', 'data', 'id'], bus),
      is_active: path(['attributes', 'is-active'], bus),
    };

    return (
      <Grid fluid>
        <Row>
          <Col style={{ margin: 20, width: '100%' }}>
            <CardHeader title="Bus wijzigen" />

            <Divider />

            <BusForm
              initialValues={initialValues}
              onSubmit={async (values) => {
                try {
                  const entity = {
                    type: 'vehicle',
                    id: bus.id,
                    attributes: {
                      'license-plate': values.license_plate,
                      'vehicle-number': values.vehicle_number,
                      'year-of-registration': values.year_of_registration,
                      'euronorm': values.euronorm,
                      'seats': values.seats,
                      'standing-places': values.standing_places,
                      'bikes-allowed': values.bikes_allowed,
                      'toilet-available': values.toilet_available,
                      'company': `${apiEndpoint}/company/${values.company}`,
                    },
                  };

                  /**
                   * If `values.photo` is not a data-URI of an image, it does
                   * not need updating.
                   */
                  if (values.photo && values.photo.startsWith('data:image')) entity.attributes['photo'] = values.photo;

                  // If the bus' active state has changed, update it.
                  if (typeof values.is_active === 'boolean' &&
                      values.is_active !== path(['attributes', 'is-active'], bus))
                    entity.attributes['is-active'] = values.is_active;

                  await updateResource(entity);
                  closeLeftBarModule('bus');
                  showSnackbarMessage('Bus gewijzigd');
                } catch (exc) {
                  let errors = {};
                  const res = await exc.response.json();

                  res.errors.forEach(e => {
                    const field = path(['source', 'pointer'], e)
                      .replace('/data/attributes/', '')
                      .replace('-', '_');

                    if (field === 'non_field_errors') errors._error = e.detail;
                    else {
                      errors[field] = e.detail;

                      switch (field) {
                        case 'license_plate': {
                          errors[field] += ' (voorbeeld: BP-NN-74)';
                          break;
                        }
                        case 'vehicle_number': {
                          errors[field] += ' (voorbeeld: 7153)';
                          break;
                        }
                        case 'year_of_registration': {
                          errors[field] += ' (voorbeeld: 2004)';
                          break;
                        }
                        case 'euronorm': {
                          errors[field] += ' (voorbeeld: Euro 3)';
                          break;
                        }
                        case 'seats': {
                          errors[field] += ' (voorbeeld: 42)';
                          break;
                        }
                        case 'standing_places': {
                          errors[field] += ' (voorbeeld: 12)';
                          break;
                        }
                        case 'company': {
                          errors[field] += ' (kies een bedrijf uit de lijst)';
                          break;
                        }
                      }
                    }
                  });

                  showSnackbarMessage('Er is iets fout gegaan bij het wijzigen van de bus.');

                  throw new SubmissionError(errors);
                }
              }}
              handleDelete={async () => {
                try {
                  const entity = {
                    type: 'vehicle',
                    id: bus.id,
                    attributes: { deleted_at: new Date() },
                  }

                  await updateResource(entity);
                  closeLeftBarModule('bus');
                  showSnackbarMessage('Bus verwijderd');
                } catch (exc) {
                  showSnackbarMessage('Er is iets misgegaan bij het verwijderen van de bus.');

                  throw new SubmissionError(exc);
                }
              }}
            />
          </Col>
        </Row>
      </Grid>
    );
  };
}

function selectBus(state, id) {
  const buses = state.api.vehicle && state.api.vehicle.data || [];

  return find(propEq('id', id))(buses);
}

const mapStateToProps = (state, ownProps) => ({
  apiEndpoint: path(['api', 'endpoint', 'axiosConfig', 'baseURL'], state),
  bus: selectBus(state, ownProps.extra.id),
});

const mapDispatchToProps = {
  readEndpoint,
  updateResource,
  closeLeftBarModule,
  showSnackbarMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusEdit);
